import { Paper, PaperProps, useTheme } from '@mui/material';
import React from 'react';
import { getTableStyles } from '../config/theme';

interface PortalTableProps extends Omit<PaperProps, 'variant'> {
    children: React.ReactNode;
}

/**
 * Standardized table wrapper for Portal screens
 * Styling controlled globally in theme.ts → PortalUIConfig.table.shadow
 */
export const PortalTable: React.FC<PortalTableProps> = ({
    children,
    sx = {},
    ...props
}) => {
    const theme = useTheme();

    return (
        <Paper
            sx={getTableStyles(theme, {
                width: '100%',
                overflow: 'hidden',
                ...sx
            })}
            {...props}
        >
            {children}
        </Paper>
    );
};

export default PortalTable;

